import React, { useState } from 'react'
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const btn = [
	{
		path: "/home",
		name: "صفحه اصلی"
	},
	{
		path: "/price",
		name: "آرشیو قیمت ها"
	},
	{
		path: "/news",
		name: "آخرین اخبار"
	},
]

const TabsRouter = props => {
	const history = useHistory();
	const dispatch = useDispatch();
	const activeTabBar = useSelector(
		(state) => state.persistedParams.activeTabBar
	)

	const {
		layoutStyle = "_layout_01",
	} = props

	const tabButton = (path, indx) => {
		history.push(path);
		dispatch({
			type: "ACTIVE_TAB_BAR",
			payload: indx
		})
	}

	return (
		<div className={`TabsRouter ${layoutStyle}`}>
			<nav className="_nav">
				<div>
					{btn.map((bt, index) => {
						return (
							<button style={{ color: activeTabBar == index +1 ? '#f6c244' : '#909090', borderBottom: activeTabBar == index+1 ? ' 1px solid #f6c244' : undefined}} key={index} onClick={() => tabButton(bt.path, index+1)}>{bt.name}</button>
						)
					})}
				</div>

			</nav>
			<div className="_content">

			</div>
		</div>
	)

}


export default TabsRouter
